import { render, staticRenderFns } from "./LandingFeaturesSimple.vue?vue&type=template&id=7675e226"
import script from "./LandingFeaturesSimple.vue?vue&type=script&lang=js"
export * from "./LandingFeaturesSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports